import firebase from 'firebase/app';
import 'firebase/storage';

export function uploadFile(file, storagePath) {
  const storageRef = firebase.storage().ref();
  const ref = storageRef.child(storagePath);
  const uploadTask = ref.put(file);
  return uploadTask;
}
